var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bottom" }, [
    _c("div", { staticClass: "btm-panel" }, [
      _c("div", { staticClass: "intro" }, [
        _c("img", {
          staticClass: "logo",
          attrs: { src: "/static/image/logo_head.png" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "tag-panel" }, [
          _c(
            "div",
            { staticClass: "tag c2" },
            [
              _c("div", { staticClass: "item" }, [
                _vm._v(_vm._s(_vm.navs.hxjsNavs.title))
              ]),
              _vm._v(" "),
              _vm._l(_vm.navs.hxjsNavs.subTitle, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item a",
                    on: {
                      click: function($event) {
                        return _vm.pushView(item, 2)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.title))]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tag c3" },
            [
              _c("div", { staticClass: "item" }, [
                _vm._v(_vm._s(_vm.navs.cpzxNavs.title))
              ]),
              _vm._v(" "),
              _vm._l(_vm.navs.cpzxNavs.subTitle, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item a",
                    on: {
                      click: function($event) {
                        return _vm.pushView(item, 3)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.title))]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tag c1" },
            [
              _c("div", { staticClass: "item" }, [
                _vm._v(_vm._s(_vm.navs.newsNavs.title))
              ]),
              _vm._v(" "),
              _vm._l(_vm.navs.newsNavs.subTitle, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item a",
                    on: {
                      click: function($event) {
                        return _vm.pushView(item, 4)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.title))]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tag c4" },
            [
              _c("div", { staticClass: "item" }, [
                _vm._v(_vm._s(_vm.navs.supportNavs.title))
              ]),
              _vm._v(" "),
              _vm._l(_vm.navs.supportNavs.subTitle, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item a",
                    on: {
                      click: function($event) {
                        return _vm.pushView(item, 5)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.title))]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tag c4" },
            [
              _c("div", { staticClass: "item" }, [
                _vm._v(_vm._s(_vm.navs.joinusNavs.title))
              ]),
              _vm._v(" "),
              _vm._l(_vm.navs.joinusNavs.subTitle, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item a",
                    on: {
                      click: function($event) {
                        return _vm.pushView(item, 6)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.title))]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "tag c1" },
            [
              _c("div", { staticClass: "item" }, [
                _vm._v(_vm._s(_vm.navs.aboutNavs.title))
              ]),
              _vm._v(" "),
              _vm._l(_vm.navs.aboutNavs.subTitle, function(item, index) {
                return _c(
                  "div",
                  {
                    key: index,
                    staticClass: "item a",
                    on: {
                      click: function($event) {
                        return _vm.pushView(item, 1)
                      }
                    }
                  },
                  [_vm._v(_vm._s(item.title))]
                )
              })
            ],
            2
          ),
          _vm._v(" "),
          _vm._m(0),
          _vm._v(" "),
          _vm._m(1)
        ])
      ]),
      _vm._v(" "),
      _vm._m(2)
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "tag c5" }, [
      _c("div", { staticClass: "item" }, [_vm._v("联系方式")]),
      _vm._v(" "),
      _c("div", { staticClass: "item a" }, [
        _vm._v(
          "\n            地址：南京市鼓楼区清江南路18号鼓楼创新广场D栋18层\n          "
        )
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "item a" }, [_vm._v("电话：400-1331-551")]),
      _vm._v(" "),
      _c("div", { staticClass: "item a" }, [
        _vm._v("邮箱：business@cnewmedical.com")
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-foot" }, [
      _c("div", { staticClass: "logo-foot_c" }, [
        _c("img", {
          staticClass: "t_image",
          attrs: { src: "/static/image/img_gongzhonghao@2x.png" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "label" }, [_vm._v("关注晨新医疗公众号")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "logo-foot_c" }, [
        _c("img", {
          staticClass: "t_image",
          attrs: { src: "/static/image/img_gongzhonghao2@2x.png" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "label" }, [_vm._v("关注晨新致远公众号")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "logo-foot_c" }, [
        _c("img", {
          staticClass: "t_image",
          attrs: { src: "/static/image/img_gongzhonghao_peizhenhui@2x.png" }
        }),
        _vm._v(" "),
        _c("div", { staticClass: "label" }, [_vm._v("关注陪诊汇公众号")])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "copy" }, [
      _c("div", { staticClass: "value" }, [
        _vm._v(
          "\n        版权所有 © 2022 晨新医疗 cnewmedical 苏ICP备2023047460号-1\n      "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-40ab164b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-40ab164b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Footer.vue
// module id = null
// module chunks = 